import type { Location } from 'react-router-dom';

/** The parts of a location the leave rule reads. */
export type LeaveLocation = Pick<Location, 'pathname' | 'search'>;

/**
 * Which navigations the Brand Workspace pages ask about before their unsaved changes are lost (web.md
 * §2.3). Passed as `shouldBlock` to the R1 guard (useUnsavedChangesGuard) by the wizard and the Edit
 * pages, one guard per page (react-router keeps a single active blocker).
 *
 * - A change of pathname asks: another Edit page, the wizard, leaving the area.
 * - A workspace switch asks: `?ws=a` to `?ws=b` on the same page, which would otherwise drop the edits
 *   silently (today's WorkspaceFormPage does).
 * - Anything else passes: TenantProvider's `replace` that only adds `?ws` (none before), the Content
 *   Composer and Generate dialogs (`?compose=`, `?generate=`), a hash.
 */
export function brandLeaveBlocks({
  currentLocation,
  nextLocation,
}: {
  currentLocation: LeaveLocation;
  nextLocation: LeaveLocation;
}): boolean {
  if (currentLocation.pathname !== nextLocation.pathname) return true;
  const from = new URLSearchParams(currentLocation.search).get('ws');
  const to = new URLSearchParams(nextLocation.search).get('ws');
  return from !== null && to !== null && from !== to;
}
